export const RADIO_LABEL_POSITIONS = {
  AFTER: 'after',
  BEFORE: 'before',
};

export const RADIO_SIZES = {
  LARGE: 'large',
  SMALL: 'small',
  STANDARD: 'standard',
};
